// @flow
// $FlowFixMe
import { logger } from 'ks-logger';
import events from 'events';




//
// ─── VARIABLES ──────────────────────────────────────────────────────────────────
//
const console = logger("@api_tyro");


const API_KEY = "123test";


const POS_INFO = {
  posProductVendor: "Krispsystems",
  posProductName: "Krisp POS",
  posProductVersion: "0.1"
}




//
// ─── EXPORT FUNCTIONS ───────────────────────────────────────────────────────────
//
export function getTyroClient(): ?Object {
  try {
    // $FlowFixMe
    return new TYRO.IClient(API_KEY, POS_INFO); // eslint-disable-line
  } catch(err) {
    console.error("@getTyroClient: ", err.message || err);
    return undefined;
  }
}




export function tyroCancelTransaction(client: Object): void {
  try {
    if (!client) {
      throw new Error("Tyro client unavailable.");
    }

    client.cancelCurrentTransaction();
  } catch(err) {
    throw err;
  }
}




export function tyroPairTerminal(merchantId: string, terminalId: string): Object {
  try {
    const emitter = new events.EventEmitter();
    const client = getTyroClient();

    if (!client) {
      throw new Error("Tyro client unavailable.");
    }

    client.pairTerminal(merchantId, terminalId, getEmitterCallback(emitter, "message"));

    return {
      client, 
      emitter
    };

  } catch(err) {
    console.error("@tyroPairTerminal: ", err.message || err);
    throw err;
  }
}




export function tyroPurchase(opts: Object = {}): Object {
  try {
    const emitter = new events.EventEmitter();
    const client = getTyroClient();

    if (!client) {
      throw new Error("Tyro client unavailable.");
    }

    client.initiatePurchase({
      integratedReceipt : false,
      enableSurcharge   : true,
      amount            : "0",
      cashout           : "0",
      mid               : "",
      tid               : "",
      integrationKey    : "",
      transactionId     : "",
      ...opts
    },
    {
      questionCallback            : getEmitterCallback(emitter, "question"),
      statusMessageCallback       : getEmitterCallback(emitter, "message"),
      transactionCompleteCallback : getEmitterCallback(emitter, "complete"),
      receiptCallback             : getEmitterCallback(emitter, "receipt"),
    });

    return {
      client,
      emitter
    };

  } catch(err) {
    console.error("@tyroPurchase: ", err.message || err);
    throw err;
  }
}




export function tyroRefund(opts: Object = {}) {
  try {
    const emitter = new events.EventEmitter();
    const client = getTyroClient();

    if (!client) {
      throw new Error("Tyro client unavailable.");
    }

    client.initiateRefund({
      amount            : "0",
      integratedReceipt : false,
      mid               : "",
      tid               : "",
      integrationKey    : "",
      transactionId     : "",
      ...opts
    },
    {
      questionCallback            : getEmitterCallback(emitter, "question"),
      statusMessageCallback       : getEmitterCallback(emitter, "message"),
      transactionCompleteCallback : getEmitterCallback(emitter, "complete"),
      receiptCallback             : getEmitterCallback(emitter, "receipt"),
    });
    
    return {
      client,
      emitter
    };

  } catch(err) {
    console.error("@tyroRefund: ", err.message || err);
    throw err;
  }
}




//
// ─── UTILITY FUNCTION ───────────────────────────────────────────────────────────
//
function getEmitterCallback(emitter, event) {
  return (...args) => {
    emitter.emit(event, ...args);
  }
}